export default __webpack_public_path__ + "static/media/trog_logo.8b135eda.png";